"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
class CKEditor extends react_1.PureComponent {
    constructor(props) {
        super(props);
        this.id = '_' + Math.random().toString(36).substr(2, 9);
        this.editor = '';
        this.getLabel = () => {
            let { label, isRequired } = this.props;
            if (label) {
                return (react_1.default.createElement("p", { className: 'mb-2' },
                    react_1.default.createElement("label", { htmlFor: this.id, className: 'mb-0' },
                        label,
                        isRequired ? '*' : '')));
            }
            else {
                return null;
            }
        };
        this.id = props.id || this.id;
    }
    componentDidMount() {
        let { inline, readonly, height, onSave, additionalExtraPlugins, additionalToolbarGroups, isCustomPlugins } = this.props;
        let extraPlugins = ['placeholder', 'indentblock', 'sourcearea'];
        let toolbarGroups = [
            { name: 'tools' },
            { name: 'document', groups: ['mode', 'document', 'doctools'] },
            { name: 'clipboard', groups: ['clipboard', 'undo'] },
            { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
            { name: 'insert' },
            { name: 'forms' },
            '/',
            { name: 'links' },
            { name: 'basicstyles', groups: ['basicstyles'] },
            { name: 'paragraph', groups: ['list', 'indent', 'align'] },
            { name: 'styles' },
            { name: 'colors' },
            '/',
        ];
        onSave && extraPlugins.push('save');
        extraPlugins.push('base64image');
        if (isCustomPlugins) {
            if (additionalExtraPlugins) {
                for (let additionalExtraPlugin of additionalExtraPlugins) {
                    extraPlugins.push(additionalExtraPlugin);
                }
            }
            if (additionalToolbarGroups) {
                for (let additionalToolbarGroup of additionalToolbarGroups) {
                    toolbarGroups.push(additionalToolbarGroup);
                }
            }
        }
        else {
            extraPlugins.push('font');
            extraPlugins.push('justify');
            extraPlugins.push('lineheight');
            extraPlugins.push('colorbutton');
            toolbarGroups = [...toolbarGroups, ...[
                    { name: 'forms' },
                    { name: 'styles' },
                    { name: 'font' },
                    { name: 'colors' }
                ]
            ];
        }
        const config = {
            language: 'ru',
            toolbarGroups: toolbarGroups,
            removeButtons: 'Strike,Styles,Image',
            format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address',
            extraPlugins: extraPlugins,
            readOnly: readonly,
            allowedContent: true,
            uploadUrl: '/cdn/upload',
        };
        this.editor = inline ?
            window.CKEDITOR.inline(this.id, config) :
            window.CKEDITOR.replace(this.id, config);
        this.editor.config.height = height || 250;
        this.editor.setData(this.props.data);
        onSave && this.editor.on('save', () => {
            onSave(this.editor.getData());
            return false;
        });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.editor.setData(this.props.data);
    }
    componentWillUnmount() {
        window.CKEDITOR.instances[this.id].removeAllListeners();
    }
    render() {
        let { readonly, className } = this.props;
        return (react_1.default.createElement("div", { className: className },
            this.getLabel(),
            readonly ? react_1.default.createElement("div", { id: this.id }) : react_1.default.createElement("textarea", { id: this.id })));
    }
}
exports.default = CKEditor;
//# sourceMappingURL=CKEditor.js.map